import { render, staticRenderFns } from "./wedding-rings.vue?vue&type=template&id=fb6f41ce&"
import script from "./wedding-rings.vue?vue&type=script&lang=js&"
export * from "./wedding-rings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports